import type { UserDto, UserDtoDocumentsInnerTypeEnum } from "../api/api";

/**
 * Required document types for onboarding
 */
export const REQUIRED_DOCUMENTS: UserDtoDocumentsInnerTypeEnum[] = [
    "CR",
    "TAX_CARD",
];

/**
 * Check if user has uploaded all required documents
 */
export function hasAllDocumentsUploaded(user?: UserDto): boolean {
    if (!user?.documents || user.documents.length === 0) {
        return false;
    }

    // Check if all required document types are uploaded
    const uploadedTypes = new Set(
        user.documents
            .filter((doc) => doc.uploaded)
            .map((doc) => doc.type)
            .filter((type): type is UserDtoDocumentsInnerTypeEnum => type !== undefined)
    );

    return REQUIRED_DOCUMENTS.every((requiredType) =>
        uploadedTypes.has(requiredType)
    );
}

/**
 * Get missing document types
 */
export function getMissingDocuments(
    user?: UserDto
): UserDtoDocumentsInnerTypeEnum[] {
    if (!user?.documents || user.documents.length === 0) {
        return REQUIRED_DOCUMENTS;
    }

    const uploadedTypes = new Set(
        user.documents
            .filter((doc) => doc.uploaded)
            .map((doc) => doc.type)
            .filter((type): type is UserDtoDocumentsInnerTypeEnum => type !== undefined)
    );

    return REQUIRED_DOCUMENTS.filter((type) => !uploadedTypes.has(type));
}

/**
 * Get document display name
 */
export function getDocumentDisplayName(
    type: UserDtoDocumentsInnerTypeEnum
): string {
    const names: Record<UserDtoDocumentsInnerTypeEnum, string> = {
        CR: "Commercial Registration",
        TAX_CARD: "Tax Card",
    };
    return names[ type ] || type;
}

